import { firebaseAuthProvider } from './firebase'
import { tokenAuthProvider } from './token'

export type { AuthenticatedUser, AuthProvider } from './types'

const provider = import.meta.env.VITE_AUTH_PROVIDER || 'firebase'

export const authProvider = provider === 'token' ? tokenAuthProvider : firebaseAuthProvider
